import { Container, Icon, Typography } from '@design-system';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { MdKeyboardArrowUp } from 'react-icons/md';
import './CollapsableContainer.scss';

export type CollapsableContainerProps = { title: string; defaultOpen?: boolean } & React.HTMLAttributes<HTMLDivElement>;

export const CollapsableContainer: React.FC<CollapsableContainerProps> = ({
    children,
    title,
    defaultOpen = false,
    className,
    ...props
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <Container className={`collapsable-container ${className ?? ''}`} onClick={() => setIsOpen(!isOpen)} bordered="grey" {...props}>
            <div className="collapsable-container-header">
                <Typography intrinsic="h4">{title}</Typography>
                <motion.div animate={{ rotate: isOpen ? 0 : 180 }} transition={{ duration: 0.3 }}>
                    <Icon icon={<MdKeyboardArrowUp />} size={24} />
                </motion.div>
            </div>
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        className="collapsable-container-content"
                        initial={{ height: 0, opacity: 0, overflow: 'hidden' }}
                        animate={{
                            height: 'auto',
                            opacity: 1,
                            overflow: 'visible',
                            transition: {
                                height: { duration: 0.3, ease: 'easeInOut' },
                                opacity: { duration: 0.2, delay: 0.2 }
                            }
                        }}
                        exit={{
                            height: 0,
                            opacity: 0,
                            overflow: 'hidden',
                            transition: {
                                height: { duration: 0.3, ease: 'easeInOut' },
                                opacity: { duration: 0.1 }
                            }
                        }}
                    >
                        {children}
                    </motion.div>
                )}
            </AnimatePresence>
        </Container>
    );
};
